module.exports = __webpack_public_path__ + "static/media/estate-clarity-activity-userflow-new.715868d4.jpg";